import { navStore } from "../camera/nav.js";
import { vehicleHub } from "./hub.js";
import { vehicleStore } from "./store.js";

/**
 * Mock-mode test hook (`__uzVehicles`): reads the vehicle state and drives it without pixel
 * picking. Deterministic: tests set the keys and read the pose, nothing depends on timers.
 */
export function installVehicleHook(): () => void {
  if (import.meta.env["VITE_UZ_MOCK"] !== "1") return () => undefined;
  const hook = {
    state: () => {
      const s = vehicleStore.getState();
      return {
        catalog: s.catalog.length,
        mine: s.mine.map((v) => ({ ...v })),
        credits: s.credits,
        drivingId: s.drivingId,
        galeriOpen: s.galeri.open,
        topUpOpen: s.topUp.open,
        near: s.near,
        error: s.error,
        navMode: navStore.getState().mode,
      };
    },
    car: () => {
      const c = vehicleStore.car;
      return c
        ? { x: c.x, z: c.z, yaw: c.yaw, kmh: Math.hypot(c.vx, c.vz) * 3.6, distance: c.distance }
        : null;
    },
    /** The map camera over a spot (screenshots). */
    look: (x: number, z: number, dx = 26, h = 16, dz = 30) => {
      if (navStore.getState().mode !== "orbit") navStore.setMode("orbit");
      navStore.requestFlight([x, 1, z], [x + dx, h, z + dz]);
    },
    openGaleri: (dealerId: string | null = null) => vehicleStore.openGaleri(dealerId),
    buy: (modelId: string, color: string) => vehicleStore.buy(modelId, color),
    enter: (id: string) => vehicleStore.enter(id),
    exit: () => vehicleStore.exit(),
    /** Plays another driver: a pose message as the server would relay it. */
    remotePose: (vehicleId: string, x: number, z: number, yawDeg: number, speed = 0) =>
      vehicleHub.ingest({ type: "vehicle.pose", vehicleId, x, z, yawDeg, speed }),
    sentPoses: () => [...vehicleHub.sent],
    teleportCar: (x: number, z: number, yaw: number) => {
      if (vehicleStore.car) vehicleStore.car = { ...vehicleStore.car, x, z, yaw, vx: 0, vz: 0 };
    },
  };
  (globalThis as { __uzVehicles?: typeof hook }).__uzVehicles = hook;
  return () => {
    delete (globalThis as { __uzVehicles?: typeof hook }).__uzVehicles;
  };
}
